// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioPlayerTrackCaption__caption-aa1709 {
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/AudioPlayer/AudioPlayerUI/AudioPlayerTrackCaption/AudioPlayerTrackCaption.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,4BAAA;EACA,8CAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".caption {\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"caption": `AudioPlayerTrackCaption__caption-aa1709`
};
module.exports = ___CSS_LOADER_EXPORT___;
